import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Products } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Products.Pages.CATALOG}`,
    name: Products.Pages.CATALOG,
    // component: () => import(/* webpackChunkName: "catalog" */ './views/Catalog.vue'),
    component: () => import(/* webpackChunkName: "catalog" */ './views/Catalog1.vue'),
    meta: {
      access_roles: RouteRoles[Products.Pages.CATALOG],
    },
  },
  {
    path: `/${Products.Pages.PRODUCT_DETAIL}/:id`,
    name: Products.Pages.PRODUCT_DETAIL,
    component: () => import(/* webpackChunkName: "product-detail" */ './views/ProductDetail.vue'),
    meta: {
      access_roles: RouteRoles[Products.Pages.PRODUCT_DETAIL],
    },
  },
];

export default routes;
